const IMPERSONATION_EMAIL_KEY = "yeschef_impersonation_email";
const IMPERSONATION_ORGANIZATION_KEY = "yeschef_impersonation_organization";
const IMPERSONATION_CONCEPT_KEY = "yeschef_impersonation_concept";

function normalizeEmail(value: string): string {
  return value.trim().toLowerCase();
}

export function getImpersonationEmail(): string | null {
  const raw = sessionStorage.getItem(IMPERSONATION_EMAIL_KEY);
  if (!raw) return null;

  const normalized = normalizeEmail(raw);
  if (!normalized) return null;

  return normalized;
}

export function setImpersonationEmail(email: string): void {
  const normalized = normalizeEmail(email);
  if (!normalized) return;
  sessionStorage.setItem(IMPERSONATION_EMAIL_KEY, normalized);
}

function normalizeOptionalLabel(value?: string | null): string | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
}

export function setImpersonationContext(params: {
  email: string;
  organizationName?: string | null;
  conceptName?: string | null;
}): void {
  setImpersonationEmail(params.email);

  const organization = normalizeOptionalLabel(params.organizationName);
  if (organization) {
    sessionStorage.setItem(IMPERSONATION_ORGANIZATION_KEY, organization);
  } else {
    sessionStorage.removeItem(IMPERSONATION_ORGANIZATION_KEY);
  }

  const concept = normalizeOptionalLabel(params.conceptName);
  if (concept) {
    sessionStorage.setItem(IMPERSONATION_CONCEPT_KEY, concept);
  } else {
    sessionStorage.removeItem(IMPERSONATION_CONCEPT_KEY);
  }
}

export function getImpersonationOrganization(): string | null {
  const raw = sessionStorage.getItem(IMPERSONATION_ORGANIZATION_KEY);
  return normalizeOptionalLabel(raw);
}

export function getImpersonationConcept(): string | null {
  const raw = sessionStorage.getItem(IMPERSONATION_CONCEPT_KEY);
  return normalizeOptionalLabel(raw);
}

export function clearImpersonationEmail(): void {
  sessionStorage.removeItem(IMPERSONATION_EMAIL_KEY);
  sessionStorage.removeItem(IMPERSONATION_ORGANIZATION_KEY);
  sessionStorage.removeItem(IMPERSONATION_CONCEPT_KEY);
}
